import { H } from "highlight.run";
import { consentManager } from "./consent";
import { HIGHLIGHT_CONFIG } from "./config";

/**
 * Initialize error tracking based on consent
 * Only records session replay on errors (not full sessions)
 */
export function initErrorTracking() {
  const consent = consentManager.getConsent();
  
  if (consent.crash && HIGHLIGHT_CONFIG.enabled) {
    // User consented to crash reporting - enable with errors-only mode
    H.start();
    console.log('[ErrorTracking] Highlight enabled (EU, errors-only, 10% sampling)');
  } else {
    // User declined, hasn't consented, or kill-switch is off
    console.log('[ErrorTracking] Highlight disabled');
  }
}

/**
 * Update tracking when consent changes
 */
export function updateErrorTrackingConsent(crashConsent: boolean) {
  if (crashConsent) {
    H.start();
    console.log('[ErrorTracking] Highlight enabled');
  } else {
    H.stop();
    console.log('[ErrorTracking] Highlight disabled');
  }
}

/**
 * Manually track an error (for custom error handling)
 */
export function trackError(error: Error, message?: string, metadata?: Record<string, any>) {
  const consent = consentManager.getConsent();
  
  if (!consent.crash) {
    console.log('[ErrorTracking] Error blocked (no consent):', error.message);
    return;
  }
  
  H.consumeError(error, message || error.message, metadata);
}
